import {
  getOrganizationApi,
  updateOrganizationApi,
  mediaUploadApi,
  getOrganizationTagsApi,
  saveOrganizationTagApi,
  updateOrganizationTagApi,
  getReferralCodeApi,
  shareReferralCodeApi,
  uploadEmployeesCSVApi,
  uploadObjectivesCSVApi,
  uploadGoalsCSVApi,
  getOrgModulesSettingsApi,
  setOrgModulesSettingsApi,
  getOrganizationFunctionsApi,
  saveCompetencyApi,
  getCompetenciesApi,
  updateCompetencyApi,
  getObjectiveSettingsApi,
  setObjectiveSettingsApi,
  getTimeBoundTimePeriodsApi,
  getTimeBoundObjectivesApi,
  getTimeBoundObjectivesTreeApi,
  getObjectiveTimelineListApi,
  importTimePeriodObjectivesApi,
  saveObjectiveApi,
  updateObjectiveApi,
  cloneObjectiveApi,
  deleteObjectiveApi,
  getCompetenciesForEmployeeApi,
  getRoleBasedCompetenciesEnabledApi,
  getOrganizationGradesApi,
  reorderOrganizationGradesApi,
  getObjectiveHierarchyIdsApi,
  getEmployeeCountApi,
  getNotificationChannelDetailsApi,
  toggleNotificationChannelApi,
  getNotificationEventChannelDetailsApi,
  toggleNotificationEventChannelApi,
  setDefaultNotificationSettingsApi,
  resetDefaultNotificationSettingsApi,
  resetDefaultNotificationSettingForEmployeesApi,
  toggleNotificationChannelForEmployeesApi,
  getObjectiveTimeboundFromIdApi,
  uploadEmployeeCSVStatusApi,
  downloadEmployeeCSVStatusApi,
  getApplicableCompetenciesForEmployeesApi,
  uploadCompetenciesCSVApi,
  setObjectiveDisplaySettingsApi,
  getCohortManagersListApi,
  getAllTemplatesApi,
  getSpecificTemplateApi,
  getSelectedTemplateApi,
  setSelectedTemplateApi,
  createTemplateApi,
  updateTemplateApi,
  deleteTemplateApi,
  setObjectiveBehaviourApi,
} from 'api/admin';
import { addNewEmployeeApi, searchEmployees } from 'api/employee';
import { searchAutoCompleteApi } from 'api/search';
import OrgObjective from 'models/orgObjective';
import { getGoalsTreeView } from 'screens/Team/Rabbit/Goals/AgGridTreeView/services';
import { processTreeAPIData } from 'screens/Team/Rabbit/Goals/Tree/RabbitTreeView/helpers';
import { getStartTSEndTSFromDateFilters } from 'screens/Team/TeamPageFilters/helper';
import {
  EVENTS_ENUM,
  EVENT_MODULE_ENUM,
  NOTIFICATION_CHANNELS,
  NOTIFICATION_EVENTS_META,
  API_EVENTS_TO_FE_EVENTS_MAPPING,
  FE_MODULE_TO_BE_MODULE_NAME_MAP,
} from 'screens/admin/Notifications/Constants/NotificationSettingsConstants';

import { getEpochFromDate, pickFromObject } from 'constants/helper';

import { constructFiltersObject } from 'services/task';

import { updateEmployee as updateEmployeeReference } from './auth';
import {
  getOrganizationObjectFromRes,
  getOrganizationTagObjectFromRes,
  getEmployeeObjectFromRes,
  formatPrimaryAndSecondaryPodForAPICall,
  getCompetenciesFromRes,
} from './helpers/admin';
import { parseSearchAutoCompleteRes } from './helpers/search';

/*
  Organization
 */
export const getOrganization = (orgId) =>
  getOrganizationApi(orgId).then((res) => getOrganizationObjectFromRes(res.entity));

export const updateOrganization = ({
  id,
  orgName,
  logoUrl,
  applauseRefillFrequency,
  meshMoneyToINRExchangeRate,
  sharedMeshMoney,
  createdDate,
  isEnterpriseOrg,
  checkinFrequency,
  timezoneOffsetDiff,
  planType,
  country,
  currency,
  language,
  defaultTimezoneOffsetDiff,
  organizationStatus,
  startMonth,
  displayNameConfig,
  timezone,
  employeeUniqueKey,
  // thi api requires the whole JSON object, so we are passing the whole object
  ...rest
}) =>
  updateOrganizationApi({
    uuid: id,
    createdTS: createdDate && getEpochFromDate(createdDate),
    orgName,
    logoUrl,
    applauseRefillFrequency,
    meshMoneyToINRExchangeRate,
    sharedMeshMoney,
    isEnterpriseOrg,
    checkinFrequency,
    timezoneOffsetDiff,
    planType,
    country,
    currency,
    language,
    defaultTimezoneOffsetDiff,
    organizationStatus,
    startMonth,
    displayNameConfig,
    timezone,
    employeeUniqueKey,
    ...rest,
  }).then((res) => getOrganizationObjectFromRes(res.entity));

export const uploadLogo = (logoFile) => mediaUploadApi(logoFile).then((res) => res.entity);

/*
  Organization Tag
 */
export const getOrganizationTags = ({ teamId, tagType = 'MESH_TASK', orgTagId }) =>
  getOrganizationTagsApi({ teamId, tagType, orgTagId }).then((res) =>
    res.entity.map((o) => getOrganizationTagObjectFromRes(o))
  );

/*
  Organization Tag
 */
export const getCompetencies = () =>
  getCompetenciesApi().then((res) => res.entity.map((o) => getCompetenciesFromRes(o)));

/*
  Organization Tag
 */
export const getRoleBasedCompetenciesEnabled = () => getRoleBasedCompetenciesEnabledApi().then((res) => res.entity);

/*
  Organization grades
*/
export const getOrganizationGrades = () => getOrganizationGradesApi().then((res) => res.entity);

export const reorderOrganizationGrades = (jobGrades) =>
  reorderOrganizationGradesApi({ jobGrades }).then((res) => res.entity);

/*
  Organization functions and levels
*/
export const getOrganizationFunctions = () =>
  getOrganizationFunctionsApi().then((res) => {
    const { entity } = res;
    // const modifiedRes = entity.map(r => ({
    //   ...r.value,
    //   jobGradeList: r.split.map(grade => ({ ...grade.value }))
    // }));
    return entity.childFunctions;
    // const sortedEntity = sortBy(entity, o => o.value.name.toLowerCase());
    // const modifiedRes = sortedEntity.map(r => ({
    //   ...r.value,
    //   jobGradeList: r.split.map(grade => ({ ...grade.value }))
    // }));
    // return modifiedRes;
  });

export const getCohortManagersList = () =>
  getCohortManagersListApi().then((res) => {
    const { entity } = res;
    // const modifiedRes = entity.map(r => ({
    //   ...r.value,
    //   jobGradeList: r.split.map(grade => ({ ...grade.value }))
    // }));
    return entity;
    // const sortedEntity = sortBy(entity, o => o.value.name.toLowerCase());
    // const modifiedRes = sortedEntity.map(r => ({
    //   ...r.value,
    //   jobGradeList: r.split.map(grade => ({ ...grade.value }))
    // }));
    // return modifiedRes;
  });

export const saveOrganizationTag = (
  orgTag,
  teamId,
  tagType = 'MESH_TASK',
  fieldsRequired = ['name', 'displayName', 'active', 'description']
) =>
  saveOrganizationTagApi({
    orgTag: pickFromObject(orgTag, fieldsRequired),
    teamId,
    tagType,
  }).then((res) => getOrganizationTagObjectFromRes(res.entity));

export const saveCompetency = (
  orgTag,
  teamId,
  tagType = 'MESH_TASK',
  fieldsRequired = ['name', 'displayName', 'active', 'description'],
  parentTagId = ''
) => {
  const organizationTag = {
    team: teamId
      ? {
          uuid: teamId,
        }
      : null,
    parentTag: parentTagId ? { uuid: parentTagId } : null,
    tagType,
    ...pickFromObject(orgTag, fieldsRequired),
  };
  return saveCompetencyApi({
    orgTag: organizationTag,
    jobFunctionRole: orgTag.jobFunctionRole,
  }).then((res) => getOrganizationTagObjectFromRes(res.entity));
};

export const getCompetenciesForEmployee = ({ employeeIds }) => {
  const body = {};
  if (employeeIds?.length) {
    body.employeeIds = employeeIds;
  }
  return getCompetenciesForEmployeeApi({ body }).then((res) => res.entity);
};

export const getApplicableCompetenciesForEmployees = ({ employeeIds, competencyIds }) => {
  const body = {};
  if (employeeIds?.length) {
    body.employeeIds = employeeIds;
  }
  if (competencyIds?.length) {
    body.competencyIds = competencyIds;
  }
  return getApplicableCompetenciesForEmployeesApi({ body }).then((res) => res.entity);
};

export const updateCompetency = (
  orgTag,
  teamId,
  tagType = 'MESH_TASK',
  fieldsRequired = ['name', 'displayName', 'active', 'description'],
  parentTagId = ''
) => {
  const organizationTag = {
    team: teamId
      ? {
          uuid: teamId,
        }
      : null,
    parentTag: parentTagId ? { uuid: parentTagId } : null,
    tagType,
    ...pickFromObject(orgTag, fieldsRequired),
  };
  // const jobFunctionRole = orgTag.jobFunctionRole?.map(func => ({
  //   uuid: func.uuid,
  //   jobRoleList: func.roles
  // }));
  return updateCompetencyApi({
    orgTag: { ...organizationTag, ...orgTag },
    jobFunctionRole: orgTag.jobFunctionRole,
  }).then((res) => getOrganizationTagObjectFromRes(res.entity));
};

export const updateOrganizationTag = (
  orgTag,
  teamId,
  tagType = 'MESH_TASK',
  fieldsRequired = ['name', 'displayName', 'active', 'description']
) =>
  updateOrganizationTagApi({
    tagId: orgTag.id || orgTag.uuid, // for leaderboard, the update api require to send unmapped tag object
    orgTag: pickFromObject(orgTag, fieldsRequired),
    teamId,
    tagType,
  }).then((res) => getOrganizationTagObjectFromRes(res.entity));

/*
  Referral Code
 */
export const getReferralCode = () => getReferralCodeApi().then((res) => res.entity);

export const shareReferralCode = ({ identifierId, referralCode }) => {
  const identifierType = 'EMAIL';
  return shareReferralCodeApi({ referralCode, identifierId, identifierType }).then((res) => res.entity);
};

/* Employees APIs */
export const getEmployeesInfo = ({ searchText, offset, limit }) =>
  searchEmployees({ text: searchText, limit, offset }).then((res) =>
    res.entity.map((emp) => getEmployeeObjectFromRes(emp))
  );

export const addNewEmployee = (employee, sendEmail) => {
  const employeeObject = formatPrimaryAndSecondaryPodForAPICall(employee);

  return addNewEmployeeApi(employeeObject, sendEmail).then((res) => getEmployeeObjectFromRes(res.entity));
};

export const updateEmployee = (employee, uuid) => {
  const employeeObject = formatPrimaryAndSecondaryPodForAPICall(employee);

  return updateEmployeeReference(employeeObject, uuid).then((res) => {
    // eslint-disable-next-line no-param-reassign
    if (res.manager) res.managerEmail = res.manager.email;

    return res;
  });
};

export const searchEmployeeByEmail = ({ tagType, query, widgetType, teamId }) =>
  searchAutoCompleteApi({ tagType, query, widgetType, teamId }).then((res) =>
    res.entity.map(({ employee }) => getEmployeeObjectFromRes(employee))
  );

/* Bulk Upload Employees */
export const uploadEmployeesCSV = (fileObject, sendInviteEmail = true) =>
  uploadEmployeesCSVApi(fileObject, sendInviteEmail);

/* Bulk Upload Employees */
export const uploadEmployeeCSVStatus = ({ uploadType = 'EMP_BULK_UPLOAD' }) =>
  uploadEmployeeCSVStatusApi({ uploadType }).then((res) => res?.entity);

/* Bulk Upload Status */
export const downloadEmployeeCSVStatus = (id) => downloadEmployeeCSVStatusApi(id).then((res) => res?.blob());

/* Bulk Upload Objectives */
export const uploadObjectivesCSV = (fileObject) => {
  const data = new FormData();
  data.append('file', fileObject);
  data.append('type', 'OBJECTIVE_UPLOAD');
  return uploadObjectivesCSVApi(data);
};

/* Bulk Upload Goals */
export const uploadGoalsCSV = (fileObject) => {
  const data = new FormData();
  data.append('file', fileObject);
  data.append('type', 'GOAL_UPLOAD');
  return uploadGoalsCSVApi(data);
};

/* Bulk Upload Goals */
export const uploadCompetenciesCSV = (fileObject) => {
  const data = new FormData();
  data.append('file', fileObject);
  data.append('type', 'COMPETENCY_UPLOAD');
  return uploadCompetenciesCSVApi(data);
};

/* subObjective tags. */
export const getSubObjectives = () => {
  const dummyResponse = [
    {
      tagType: 'ORGTAG',
      orgTag: {
        uuid: '15811',
        createdTS: null,
        updatedTS: null,
        name: 'CostReduction: checkSum',
        displayName: 'CostReduction: checkSum',
        imageUrl: null,
        tagType: 'SUB_OBJECTIVE_TAG',
        team: null,
        color: null,
        parentTag: {
          uuid: '15808',
          createdTS: 1594804450000,
          updatedTS: 1600172643000,
          name: 'CostReduction',
          displayName: 'CostReduction',
          imageUrl: null,
          tagType: 'GOAL',
          team: null,
          color: null,
          parentTag: null,
        },
      },
    },
    {
      tagType: 'ORGTAG',
      orgTag: {
        uuid: '16014',
        createdTS: null,
        updatedTS: null,
        name: 'CostReduction: CLoudWatchAlarms',
        displayName: 'CostReduction: CLoudWatchAlarms',
        imageUrl: null,
        tagType: 'SUB_OBJECTIVE_TAG',
        team: null,
        color: null,
        parentTag: {
          uuid: '15808',
          createdTS: 1594804450000,
          updatedTS: 1600172643000,
          name: 'CostReduction',
          displayName: 'CostReduction',
          imageUrl: null,
          tagType: 'GOAL',
          team: null,
          color: null,
          parentTag: null,
        },
      },
    },
    {
      tagType: 'ORGTAG',
      orgTag: {
        uuid: '16131',
        createdTS: null,
        updatedTS: null,
        name: 'CostReduction: cr_sa_1',
        displayName: 'CostReduction: cr_sa_1',
        imageUrl: null,
        tagType: 'SUB_OBJECTIVE_TAG',
        team: null,
        color: null,
        parentTag: {
          uuid: '15808',
          createdTS: 1594804450000,
          updatedTS: 1600172643000,
          name: 'CostReduction',
          displayName: 'CostReduction',
          imageUrl: null,
          tagType: 'GOAL',
          team: null,
          color: null,
          parentTag: null,
        },
      },
    },
    {
      tagType: 'ORGTAG',
      orgTag: {
        uuid: '16015',
        createdTS: null,
        updatedTS: null,
        name: 'CostReduction: Metrics',
        displayName: 'CostReduction: Metrics',
        imageUrl: null,
        tagType: 'SUB_OBJECTIVE_TAG',
        team: null,
        color: null,
        parentTag: {
          uuid: '15808',
          createdTS: 1594804450000,
          updatedTS: 1600172643000,
          name: 'CostReduction',
          displayName: 'CostReduction',
          imageUrl: null,
          tagType: 'GOAL',
          team: null,
          color: null,
          parentTag: null,
        },
      },
    },
  ];

  return parseSearchAutoCompleteRes(dummyResponse);

  // return searchAutoCompleteApi({
  //   query : '',
  //   widgetType: SEARCH_TAG_TYPES.goal,
  //   selectedObjectiveId: [objectiveId],
  //   tagType: SEARCH_TAG_TYPES.subObjectiveTag
  // }).then( res => console.log( res ));
};

export const updateOrganizationSubObjective = ({
  orgTag,
  teamId = null,
  tagType = 'SUB_OBJECTIVE_TAG',
  fieldsRequired = ['name', 'displayName', 'active', 'description'],
  parentTagId,
}) =>
  updateOrganizationTagApi({
    tagId: orgTag.id || orgTag.uuid, // for leaderboard, the update api require to send unmapped tag object
    orgTag: pickFromObject(orgTag, fieldsRequired),
    teamId,
    tagType,
    parentTagId,
  }).then((res) => getOrganizationTagObjectFromRes(res.entity));

export const saveOrganizationTagSubObjective = ({
  orgTag,
  teamId = null,
  tagType = 'SUB_OBJECTIVE_TAG',
  fieldsRequired = ['name', 'displayName', 'active', 'description'],
  parentTagId,
}) =>
  saveOrganizationTagApi({
    orgTag: pickFromObject(orgTag, fieldsRequired),
    teamId,
    tagType,
    parentTagId,
  }).then((res) => getOrganizationTagObjectFromRes(res.entity));

export const getOrgModulesSettings = async () => {
  const res = await getOrgModulesSettingsApi();
  return res.entity;
};

export const setOrgModulesSettings = async ({ moduleType, moduleStatus }) => {
  const res = await setOrgModulesSettingsApi({ moduleType, moduleStatus });
  return res.entity;
};

export const getObjectiveSettings = async () => {
  const res = await getObjectiveSettingsApi();
  return {
    frequencyType: res.entity.frequencyType,
    startMonth: res.entity.startMonth,
    defaultGoalVisibility: res.entity.defaultGoalVisibility,
    objectiveCreationAccess: res.entity.objectiveCreationAccess,
  };
};

export const setObjectiveSettings = async ({
  frequencyType,
  startMonth,
  defaultGoalVisibility,
  objectiveCreationAccess,
}) => {
  const res = await setObjectiveSettingsApi({
    frequencyType,
    startMonth,
    defaultGoalVisibility,
    objectiveCreationAccess,
  });
  return res.entity;
};

export const setObjectiveBehaviourSettings = async ({
  frequencyType,
  startMonth,
  defaultGoalVisibility,
  objectiveCreationAccess,
}) => {
  const res = await setObjectiveBehaviourApi({
    frequencyType,
    startMonth,
    defaultGoalVisibility,
    objectiveCreationAccess,
  });
  return res.entity;
};

export const setObjectiveDisplaySettings = async ({ moduleName, objectivesName, keyResultsName }) => {
  const res = await setObjectiveDisplaySettingsApi({ moduleName, objectivesName, keyResultsName });
  return res.entity;
};

export const getTimeBoundTimePeriods = async () => {
  const res = await getTimeBoundTimePeriodsApi();
  return res.entity;
};

export const getTimeBoundObjectives = async ({ timePeriodObj, parentId = null }) => {
  const queryParamsObj = {
    startTS: timePeriodObj.startTS,
    endTS: timePeriodObj.endTS,
    timelineTag: timePeriodObj.timelineTag,
  };
  // second nested level onwards, the tagType is 'SUB_OBJECTIVE_TAG'
  // and they also always will have a parent objective
  if (parentId) {
    queryParamsObj.tagType = 'SUB_OBJECTIVE_TAG';
    queryParamsObj.parentId = parentId;
  } else {
    queryParamsObj.tagType = 'GOAL';
  }
  const res = await getTimeBoundObjectivesApi(queryParamsObj);

  return res.entity.map((objective) => OrgObjective.fromJSON(objective));
};

export const getObjectiveTimelineList = async () => {
  const res = await getObjectiveTimelineListApi();
  return res.entity;
};

export const importTimePeriodObjectives = async ({ sourceTimePeriod, targetTimePeriod }) => {
  const res = await importTimePeriodObjectivesApi({ sourceTimePeriod, targetTimePeriod });
  return res.entity;
};

export const getObjectiveTimeboundFromId = async ({ objectiveTimeBoundId, objectiveId, timeBoundId }) => {
  // TODO: report this api returns empty array in case of non existing objective timebound id.
  const res = await getObjectiveTimeboundFromIdApi({
    objectiveTimeBoundId,
    objectiveId,
    timeBoundId,
  });
  return res.entity;
};

export const saveObjective = async ({ tag, isSubObjective = false }) => {
  const res = await saveObjectiveApi({
    tag: OrgObjective.getAPIStructure({
      ...tag,
      displayName: tag.name,
      objectiveType: isSubObjective || tag.parentTag ? 'SUB_OBJECTIVE_TAG' : tag.objectiveType,
    }),
  });
  return OrgObjective.fromJSON(res.entity);
};

// either we get newObjectiveId from autocomplete else it will be null
export const updateObjective = async ({
  tag,
  updateAllInstances = false,
  newObjectiveId = null,
  renameObjective = false,
}) => {
  // tag.isNew is required to discard existing uuid in request call, indicating we are only changing the name
  // newObjectiveId is when existing objective is selected from auto complete

  const res = await updateObjectiveApi({
    tag: OrgObjective.getAPIStructure(
      {
        ...tag,
        displayName: tag.name,
        objectiveId: tag?.isNew ? null : (newObjectiveId ?? tag.objectiveId),
      },
      renameObjective
    ),
    updateAllInstances,
    renameObjective,
  });
  return OrgObjective.fromJSON(res.entity);
};

export const cloneObjective = async ({ tag, includeObjectiveTree = false }) => {
  const res = await cloneObjectiveApi({
    tag: OrgObjective.getAPIStructure({
      ...tag,
      displayName: tag.name,
    }),
    objectiveTimeBoundId: tag.objectiveTimeBoundId,
    includeObjectiveTree,
  });
  return res.entity;
};

export const deleteObjective = async ({
  objectiveTimeBoundId,
  archiveObjectiveTree = false,
  isDeleteRevamp = false,
}) => {
  const res = await deleteObjectiveApi({
    objectiveTimeBoundId,
    archiveObjectiveTree,
    isDeleteRevamp,
  });

  return res.entity;
};

export const getNotificationChannelDetails = async () => {
  const res = await getNotificationChannelDetailsApi();
  return { channelDetailsArray: res.entity };
};

export const toggleNotificationChannel = async ({ uuid, channelType, enabled }) => {
  const res = await toggleNotificationChannelApi({
    uuid,
    channelType,
    enabled,
  });
  return res;
};

export const toggleNotificationChannelForEmployees = async ({
  uuid,
  channelType,
  enabled,
  isEmployeeNotificationSettings,
}) => {
  const res = await toggleNotificationChannelForEmployeesApi({
    uuid,
    channelType,
    enabled,
    isEmployeeNotificationSettings,
  });
  return res;
};

export const getNotificationEventChannelDetails = async ({ isEmployeeNotificationSettings, enabledFeatures = [] }) => {
  const res = await getNotificationEventChannelDetailsApi({ isEmployeeNotificationSettings });
  const checkModuleEnabled = (moduleType) => {
    switch (moduleType) {
      case 'FEEDBACK':
        return enabledFeatures.includes('FEEDBACK');
      case 'GOAL':
        return enabledFeatures.includes('GOAL');
      case 'ONE_ON_ONE_V2':
        return enabledFeatures.includes('CHECK_IN');
      case 'REVIEW':
        return enabledFeatures.includes('REVIEW');
      case 'TASK':
        return enabledFeatures.includes('TASK');
      case 'ENGAGEMENT':
        return enabledFeatures.includes('ENGAGEMENT');
      default:
        return true;
    }
  };

  // sorting the channels and events as per correct order
  // ideally BE should've sent the correct sorted array

  const { channelDetailsList, responseList: initialResponseList } = res.entity;
  const responseList = [
    ...initialResponseList,
    {
      moduleType: 'ENGAGEMENT',
      eventsDetailMap: {
        [EVENTS_ENUM.SURVEY_COMPLETION_REMINDERS]:
          NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.ENGAGEMENT_COMPLETION][EVENTS_ENUM.SURVEY_COMPLETION_REMINDERS],
      },
      order: NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.ENGAGEMENT_COMPLETION].order,
    },
    {
      moduleType: 'REVIEW',
      eventsDetailMap: {
        [EVENTS_ENUM.REVIEW_COMPLETION_REMINDERS]:
          NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW][
            [EVENTS_ENUM.REVIEW_COMPLETION_REMINDERS]
          ],
        [EVENTS_ENUM.REVIEW_CYCLE_LAUNCH_ANNOUNCEMENTS]:
          NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW][
            EVENTS_ENUM.REVIEW_CYCLE_LAUNCH_ANNOUNCEMENTS
          ],
        [EVENTS_ENUM.REVIEW_PUBLISH_REMINDERS]:
          NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW][EVENTS_ENUM.REVIEW_PUBLISH_REMINDERS],
        [EVENTS_ENUM.REVIEW_ACKNOWLEDGED]:
          NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW][EVENTS_ENUM.REVIEW_ACKNOWLEDGED],
      },
      order: NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW].order,
    },
    {
      moduleType: 'ONE_ON_ONE_V2',
      eventsDetailMap: {
        [EVENTS_ENUM.ONE_ON_ONE_REFRESH_TOKEN_FAILURE]:
          NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.ONE_ON_ONE_COMPLETION][
            EVENTS_ENUM.ONE_ON_ONE_REFRESH_TOKEN_FAILURE
          ],
      },
      order: NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.ONE_ON_ONE_COMPLETION].order,
    },
    {
      moduleType: 'GOAL',
      eventsDetailMap: {
        [EVENTS_ENUM.GOAL_CHECKIN_REMINDER]:
          NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.GOAL_CHECKIN][EVENTS_ENUM.GOAL_CHECKIN_REMINDER],
      },
      order: NOTIFICATION_EVENTS_META[EVENT_MODULE_ENUM.GOAL_CHECKIN].order,
    },
  ];
  const sortedChannelDetailsArray = channelDetailsList
    ?.filter((channel) => Object.keys(NOTIFICATION_CHANNELS).includes(channel.channelType))
    .map((channel) => ({
      ...channel,
      order: NOTIFICATION_CHANNELS[channel.channelType].order,
    }))
    .sort((a, b) => a.order - b.order);

  const sortedChannelEventDetailsArray = responseList
    ?.filter((module) => checkModuleEnabled(module.moduleType) && module.moduleType in NOTIFICATION_EVENTS_META)
    .map((module) => {
      if (module.moduleType === 'ENGAGEMENT') {
        return {
          ...module,
          eventsDetailMap: {
            ...module.eventsDetailMap,
            ENGAGEMENT_REMINDER: NOTIFICATION_EVENTS_META[module.moduleType].ENGAGEMENT_REMINDER,
          },
          order: NOTIFICATION_EVENTS_META[module.moduleType].order,
        };
      }
      return {
        ...module,
        order: NOTIFICATION_EVENTS_META[module.moduleType].order,
        featureFlag: NOTIFICATION_EVENTS_META[module.moduleType]?.featureFlag,
      };
    })
    .sort((a, b) => a.order - b.order);

  return {
    channelDetailsArray: sortedChannelDetailsArray,
    channelEventDetailsArray: sortedChannelEventDetailsArray,
  };
};

export const toggleNotificationEventChannel = async ({
  moduleType,
  mainEventType,
  channelType,
  channelState,
  isEmployeeNotificationSettings,
}) => {
  const mainEventTypesMap = Object.keys(API_EVENTS_TO_FE_EVENTS_MAPPING);
  const mainEventTypeAPI = mainEventTypesMap.find(
    (apiEventName) => API_EVENTS_TO_FE_EVENTS_MAPPING[apiEventName] === mainEventType
  );
  const moduleTypeAPI = FE_MODULE_TO_BE_MODULE_NAME_MAP[moduleType];
  if (!mainEventTypeAPI || !moduleTypeAPI) {
    console.error(`Invalid main event type or module type ${mainEventType}, ${moduleTypeAPI}`);
    return null;
  }
  const res = await toggleNotificationEventChannelApi({
    moduleType: moduleTypeAPI,
    mainEventType: mainEventTypeAPI,
    channelType,
    channelState,
    isEmployeeNotificationSettings,
  });
  return res;
};

export const setDefaultNotificationSettings = async () => {
  const res = await setDefaultNotificationSettingsApi();
  return res;
};

export const resetDefaultNotificationSettings = async ({ isMeshDefaultMapping }) => {
  const res = await resetDefaultNotificationSettingsApi({ isMeshDefaultMapping });
  return res;
};

export const resetDefaultNotificationSettingsForEmployees = async () => {
  const res = await resetDefaultNotificationSettingForEmployeesApi();
  return res;
};

export const getTimeBoundObjectivesTree = async ({ timeBound, globalFilters, teamId, selectedCohort = null }) => {
  const globalFiltersWithoutObjectiveFilter = globalFilters.filters.filter(
    (item) => item.type !== 'TIMEBOUND_OBJECTIVE'
  );
  const { startTS, endTS } = getStartTSEndTSFromDateFilters({ predefined: 'LASTYEAR' });

  const filtersForApi = constructFiltersObject([...globalFiltersWithoutObjectiveFilter]);
  const res = await getTimeBoundObjectivesTreeApi({
    timeBound,
    filters: [
      {
        type: 'TYPE',
        operatorType: 'IN',
        data: ['GOAL'],
      },
      ...filtersForApi,
    ],
    startTS,
    endTS,
    teamId,
    selectedCohort,
  });
  return processTreeAPIData(res.entity);
};

export const getObjectiveHierarchyIds = async ({ objectiveTimeBoundId }) => {
  const res = await getObjectiveHierarchyIdsApi({
    objectiveTimeBoundId,
  });
  return res?.entity;
  // return res?.entity.map(id => `${id}`);
};

export const getEmployeeCount = async ({ orgId }) => {
  const res = await getEmployeeCountApi({ orgId });
  return res?.entity;
};

// GOAL PREFERENCES

export const getAllTemplates = async () => {
  const res = await getAllTemplatesApi();
  return res;
};
export const getSpecificTemplate = async (templateId) => {
  const res = await getSpecificTemplateApi(templateId);
  return res;
};
export const getSelectedTemplate = async () => {
  const res = await getSelectedTemplateApi();
  return res;
};
export const setSelectedTemplate = async (templateId) => {
  const res = await setSelectedTemplateApi(templateId);
  return res;
};
export const createTemplate = async (body) => {
  const res = await createTemplateApi(body);
  return res;
};
export const updateTemplate = async (template, body) => {
  const res = await updateTemplateApi(template, body);
  return res;
};
export const deleteTemplate = async (templateId) => {
  const res = await deleteTemplateApi(templateId);
  console.log(res, 'asdasdasdasdasdasdas');
  return res;
};
export const getObjectiveTreeViewData = async ({
  cohort,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
  attributeFilter,
  pageType,
  ownership,
}) => {
  const res = await getGoalsTreeView({
    cohort,
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
    attributeFilter,
    pageType,
    ownership,
  });

  return processTreeAPIData(res);
};
